var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _polygon, _path10, _polygon2, _path11, _polygon3, _path12, _polygon4, _path13, _polygon5, _path14, _polygon6, _path15, _polygon7, _path16, _polygon8, _path17, _polygon9, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg357"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path314",
    d: "M0,7.5h30v15H0V7.5Z",
    style: {
      fill: "#c81010"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "bird_outline",
    d: "M15.287,8.867c-.954-.395-1.538-.466-2.19-.473-.945.007-1.396.413-2.297.45.357.385,1.651.479,2.196-.026.811.084.995.303,1.212.576-.338-.053-.729-.151-1.052.207-.274.054-.399,0-.867,0-.218,0-.294.107-.291.3.141-.195,1.116-.079,1.355,0,.184.061.379.315.611.357.609.109,1.484-.21,2.29-.427l1.744-.23h-1.196l1.497-.3h-1.627c-.034-.04-.117-.091-.183-.134.419-.269.789-.759.883-.996.755-.008,1.242-.077,1.827-.215-3.859-.429-2.979.032-3.912.91Z",
    style: {
      fill: "#f8d000"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.233,10.29c-.094,0-.184-.007-.269-.022-.135-.024-.254-.116-.37-.204-.085-.066-.166-.127-.243-.153-.243-.081-1.207-.188-1.341-.005l-.02.028v-.034c-.001-.109.022-.186.071-.237.05-.05.125-.075.23-.075.184,0,.315.009.422.016.166.01.276.018.438-.015.303-.334.665-.274.984-.22.016.002.031.006.047.008-.201-.251-.394-.465-1.181-.548-.567.52-1.859.399-2.208.023l-.017-.018h.025c.43-.019.764-.123,1.086-.224.353-.11.717-.224,1.212-.227.679.007,1.254.086,2.188.472.203-.193.318-.362.419-.513.174-.259.3-.445.758-.52.464-.076,1.259-.041,2.74.124l.067.007-.065.015c-.54.126-1.034.207-1.821.215-.098.236-.457.714-.869.985l.014.009c.06.039.121.079.153.113h1.737l-1.497.3h1.255l-1.917.253c-.151.041-.309.086-.462.13-.547.155-1.106.317-1.565.317ZM12.477,9.78c.339,0,.749.065.882.109.082.027.163.09.25.157.113.087.23.177.36.2.491.087,1.168-.108,1.823-.296.153-.044.311-.09.463-.13l1.572-.208h-1.137l1.497-.3h-1.517l-.003-.003c-.028-.033-.094-.075-.152-.113l-.043-.028.015-.009c.419-.269.785-.757.878-.991l.003-.007h.008c.758-.008,1.244-.082,1.759-.199-2.927-.321-3.06-.124-3.409.395-.102.152-.219.325-.428.521l-.006.006-.007-.003c-.934-.386-1.509-.466-2.186-.473-.49.003-.853.117-1.205.227-.318.099-.646.201-1.066.222.179.174.567.29,1.002.298.491.01.915-.116,1.161-.344l.003-.003h.006c.826.086,1.009.315,1.22.58l.018.023-.03-.005c-.025-.003-.05-.008-.076-.012-.314-.052-.671-.111-.966.216l-.002.003h-.003c-.168.035-.279.027-.448.017-.106-.007-.238-.016-.421-.016-.099,0-.169.023-.214.068-.041.042-.062.104-.065.192.077-.068.259-.092.465-.092Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "eye",
    d: "M13.503,9.495c.042,0,.075.033.075.075s-.034.075-.075.075-.075-.033-.075-.075.034-.075.075-.075Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.503,9.648c-.043,0-.078-.035-.078-.078s.035-.078.078-.078.078.035.078.078-.035.078-.078.078ZM13.503,9.498c-.04,0-.071.032-.071.071s.032.071.071.071.071-.032.071-.071c0-.04-.032-.071-.071-.071Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.263,9.84l-.015-.018c.011-.009.293-.233.555-.233v.023c-.254,0-.537.226-.54.228ZM13.986,9.612v-.023c.202,0,.513-.182.515-.184l.011.019c-.012.008-.318.187-.527.187ZM15.235,8.93c-.2-.077-.605-.084-.609-.084v-.023c.017,0,.414.007.617.085l-.008.022ZM11.252,8.908c-.255,0-.451-.052-.454-.053l.006-.023c.006.001.575.153,1.034-.067l.01.02c-.196.095-.412.123-.596.123ZM14.997,8.765c-.379-.107-.779-.042-.782-.041l-.003-.023s.409-.067.792.042l-.007.022ZM11.696,8.74l-.01-.02c.009-.005.235-.123.345-.155l.007.022c-.109.033-.339.153-.342.154ZM14.585,8.625c-.44-.098-.923-.018-.927-.018l-.003-.023s.491-.081.936.018l-.006.023ZM12.661,8.567l-.009-.022s.377-.16.785-.152v.023c-.405-.008-.773.15-.776.151Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.313,8.972c-.239,0-.439-.048-.443-.049l.006-.023c.007.002.743.178,1.076-.154l.016.016c-.166.167-.428.21-.655.21Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.488,9.177c-.447-.093-.569-.241-.573-.246l.018-.015s.124.148.561.238l-.006.023ZM12.006,9.172l-.014-.019s.304-.212.411-.395l.02.011c-.109.187-.405.394-.418.403ZM11.648,9.165l-.007-.022s.452-.132.62-.393l.019.012c-.171.268-.613.397-.632.402ZM15.676,9.122c-.117,0-.236-.089-.242-.093l.014-.018s.123.093.235.089v.023s-.003,0-.007,0ZM16.595,9.105c-.401-.047-.592-.235-.6-.243l.016-.016s.195.191.587.236l-.002.023ZM11.386,9.085c-.157,0-.264-.033-.267-.034l.007-.022c.006.002.561.174.992-.283l.017.016c-.251.264-.542.322-.749.322ZM15.771,9.052c-.151,0-.259-.091-.263-.094l.015-.017s.107.091.25.09v.023s-.001-.001-.001-.001ZM16.718,9.005c-.424-.062-.618-.226-.626-.233l.015-.017s.199.167.615.228l-.003.022ZM15.835,8.972c-.133,0-.237-.095-.242-.1l.016-.017s.12.111.261.091l.003.023c-.014.002-.026.003-.039.003ZM16.834,8.9c-.339-.023-.642-.222-.645-.225l.012-.019s.301.199.634.22l-.002.024ZM15.957,8.889c-.132,0-.274-.095-.279-.099l.012-.019s.145.099.271.095v.023h-.005ZM16.058,8.8c-.175-.009-.284-.102-.288-.107l.015-.017s.108.092.275.101v.023ZM16.937,8.796c-.414-.049-.63-.245-.631-.247l.016-.017s.212.194.618.241l-.003.024ZM16.15,8.711c-.166-.005-.293-.116-.298-.12l.015-.017s.127.111.284.115v.023ZM17.033,8.692c-.386-.03-.636-.241-.638-.243l.015-.017s.247.209.625.237l-.002.023ZM16.244,8.613c-.176-.015-.3-.093-.305-.096l.012-.019s.124.078.294.093v.023ZM17.134,8.566c-.496-.045-.648-.216-.655-.224l.017-.015s.154.171.639.216v.023ZM16.344,8.504c-.153-.015-.322-.074-.323-.074l.008-.022s.168.059.318.073l-.002.023ZM17.214,8.457c-.471-.04-.64-.22-.647-.228l.017-.016s.171.182.631.22v.024ZM16.416,8.4c-.195,0-.304-.075-.309-.078l.014-.019s.115.079.313.074v.023c-.006.001-.012.001-.018.001ZM17.271,8.357c-.337,0-.63-.218-.633-.22l.014-.018s.295.22.63.216v.023s-.007,0-.01,0ZM16.508,8.31c-.177-.002-.313-.091-.319-.095l.012-.019s.136.09.306.091v.024ZM17.314,8.281c-.234,0-.601-.219-.617-.228l.011-.019s.389.233.616.225v.023h-.01ZM16.549,8.199c-.146,0-.293-.081-.3-.085l.011-.02s.183.101.335.078l.003.023c-.016.003-.033.005-.05.005ZM17.372,8.182c-.288-.042-.6-.235-.604-.237l.012-.019s.311.192.595.234l-.003.023ZM16.644,8.117c-.212,0-.326-.121-.33-.127l.017-.016s.117.124.325.119v.023s-.007.001-.011.001ZM16.669,8.031c-.137,0-.298-.09-.305-.094l.011-.02s.207.115.343.086l.005.023c-.017.005-.035.006-.053.006ZM16.752,7.965c-.144,0-.294-.091-.301-.094l.012-.019s.157.094.297.091v.023h-.009ZM17.212,7.964c-.184,0-.343-.035-.355-.039l.006-.023c.006.001.567.127.808-.095l.016.017c-.119.11-.308.14-.474.14ZM16.927,7.884c-.19,0-.311-.06-.313-.061l.01-.02s.283.14.655-.012l.009.022c-.135.055-.258.073-.361.073Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.45,7.965c-.089,0-.142-.006-.143-.006l.002-.023s.395.039.827-.098l.007.022c-.278.089-.539.104-.693.104Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.169,9.158l-.012-.019s.266-.176.373-.373l.02.011c-.111.202-.371.375-.381.381ZM12.369,9.124l-.016-.017s.213-.208.275-.334l.02.01c-.062.129-.27.333-.279.34ZM12.567,9.071l-.016-.017s.175-.158.212-.264l.022.008c-.039.112-.21.267-.218.273ZM18.339,8.017c-.493,0-.768-.053-.772-.054l.005-.023c.006.001.606.118,1.629.005l.002.023c-.336.037-.625.05-.864.05Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.14,9.004c-.185-.087-.335-.071-.337-.07l-.002-.023c.007-.001.159-.018.35.073l-.01.02ZM15.233,8.857c-.385-.095-.723-.082-.726-.082v-.023s.345-.015.732.082l-.006.023ZM12.995,8.829c-.902-.116-1.291-.035-1.295-.034l-.005-.023s.395-.083,1.303.034l-.003.023ZM14.742,8.675c-.328-.06-.813-.035-.817-.035v-.023s.49-.025.822.035l-.005.023ZM12.056,8.64l-.01-.02s.326-.157.611-.204l.003.023c-.28.046-.6.201-.604.202ZM12.375,8.576l-.01-.02s.239-.112.583-.167l.003.023c-.339.054-.574.163-.577.165ZM13.317,8.559l-.005-.023s.452-.1.859-.044l-.003.023c-.404-.054-.848.043-.851.044ZM12.909,8.555l-.009-.022s.331-.14.726-.126v.023c-.392-.012-.715.124-.717.125ZM13.125,8.55l-.009-.022s.262-.106.712-.098v.023c-.445-.008-.7.095-.702.096ZM17.567,8.177c-.465-.092-.634-.235-.641-.241l.015-.017s.172.145.631.235l-.005.023ZM17.875,8.165c-.412-.052-.68-.201-.682-.203l.011-.02s.266.149.674.2l-.003.024ZM18.232,8.137c-.388-.01-.759-.17-.764-.171l.009-.022s.371.16.755.169v.024ZM18.564,8.071c-.386,0-.681-.069-.684-.07l.006-.023s.38.09.839.066v.023c-.054.003-.108.005-.16.005Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M14.45,9.428c-.073,0-.151-.009-.242-.024l.003-.023c.113.018.207.028.293.022.319-.175.573-.353.776-.545l.016.017c-.205.194-.462.373-.783.549h-.005c-.02.003-.04.003-.059.003Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "wavy",
    d: "M12.476,14.941c-.707-.096-1.34-.49-1.739-1.083.621.353,1.362.424,2.038.195",
    style: {
      fill: "#f8d000"
    }
  }), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M12.474,14.952c-.71-.096-1.346-.493-1.747-1.087l-.027-.041.042.024c.617.351,1.356.422,2.029.194l.007.022c-.663.225-1.391.161-2.005-.172.397.567,1.016.944,1.702,1.037v.024Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "straight",
    d: "M12.461,15.536l-2.092-.664,2.178-.269",
    style: {
      fill: "#f8d000"
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "12.458 15.546 10.317 14.866 12.547 14.59 12.549 14.614 10.423 14.876 12.465 15.524 12.458 15.546"
  })), /*#__PURE__*/React.createElement("path", {
    id: "wavy1",
    "data-name": "wavy",
    d: "M12.776,14.052c-.625-.345-1.072-.941-1.229-1.638.451.554,1.117.887,1.831.918",
    style: {
      fill: "#f8d000"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.77,14.063c-.628-.346-1.077-.946-1.235-1.645l-.01-.048.031.037c.448.55,1.112.884,1.821.915v.023c-.7-.031-1.356-.352-1.809-.885.166.672.606,1.247,1.213,1.582l-.011.022Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "straight1",
    "data-name": "straight",
    d: "M12.548,14.602l-1.71-1.375,2.128.536",
    style: {
      fill: "#f8d000"
    }
  }), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "12.541 14.611 10.79 13.204 12.968 13.752 12.963 13.774 10.886 13.251 12.554 14.593 12.541 14.611"
  })), /*#__PURE__*/React.createElement("path", {
    id: "wavy2",
    "data-name": "wavy",
    d: "M13.376,13.334c-.458-.548-.66-1.265-.555-1.971.22.679.721,1.231,1.375,1.517",
    style: {
      fill: "#f8d000"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.368,13.341c-.46-.549-.663-1.271-.557-1.98l.007-.049.015.047c.219.675.718,1.226,1.369,1.51l-.009.022c-.641-.28-1.137-.818-1.365-1.478-.089.687.115,1.381.559,1.913l-.018.015Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "straight2",
    "data-name": "straight",
    d: "M12.965,13.763l-1.097-1.9,1.791,1.269",
    style: {
      fill: "#f8d000"
    }
  }), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "12.955 13.769 11.83 11.824 13.664 13.123 13.651 13.141 11.903 11.904 12.975 13.757 12.955 13.769"
  })), /*#__PURE__*/React.createElement("path", {
    id: "wavy3",
    "data-name": "wavy",
    d: "M14.197,12.88c-.229-.676-.159-1.417.194-2.038-.04.713.227,1.408.734,1.912",
    style: {
      fill: "#f8d000"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.186,12.884c-.23-.679-.159-1.425.195-2.048l.024-.042-.002.049c-.04.709.227,1.403.731,1.903l-.016.016c-.497-.494-.765-1.173-.74-1.871-.33.608-.393,1.33-.17,1.986l-.022.008Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "straight3",
    "data-name": "straight",
    d: "M13.658,13.132l-.337-2.167,1.211,1.829",
    style: {
      fill: "#f8d000"
    }
  }), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "13.646 13.134 13.301 10.914 14.542 12.787 14.522 12.8 13.34 11.015 13.669 13.13 13.646 13.134"
  })), /*#__PURE__*/React.createElement("path", {
    id: "wavy4",
    "data-name": "wavy",
    d: "M15.125,12.753c.031-.713.364-1.38.918-1.83-.294.65-.296,1.396-.007,2.047",
    style: {
      fill: "#f8d000"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16.026,12.975c-.285-.64-.289-1.37-.014-2.012-.528.448-.847,1.097-.876,1.791h-.023c.031-.717.367-1.387.922-1.84l.037-.031-.02.044c-.293.647-.295,1.39-.007,2.038l-.019.009Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "straight4",
    "data-name": "straight",
    d: "M14.531,12.794l.469-2.144.469,2.144",
    style: {
      fill: "#f8d000"
    }
  }), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "15.457 12.796 15 10.704 14.543 12.796 14.52 12.792 15 10.596 15.48 12.792 15.457 12.796"
  })), /*#__PURE__*/React.createElement("path", {
    id: "wavy5",
    "data-name": "wavy",
    d: "M16.036,12.97c.286-.654.839-1.154,1.517-1.375-.51.5-.781,1.194-.746,1.908",
    style: {
      fill: "#f8d000"
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.797,13.503c-.034-.699.225-1.382.714-1.882-.654.227-1.186.718-1.464,1.354l-.022-.009c.287-.657.842-1.16,1.524-1.382l.047-.015-.035.034c-.506.497-.777,1.189-.742,1.899h-.022Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "straight5",
    "data-name": "straight",
    d: "M15.469,12.794l1.211-1.829-.337,2.167",
    style: {
      fill: "#f8d000"
    }
  }), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "16.354 13.133 16.331 13.13 16.66 11.015 15.478 12.8 15.459 12.787 16.699 10.914 16.354 13.133"
  })), /*#__PURE__*/React.createElement("path", {
    id: "wavy6",
    "data-name": "wavy",
    d: "M16.808,13.502c.503-.506,1.198-.774,1.911-.734-.656.283-1.16.832-1.385,1.509",
    style: {
      fill: "#f8d000"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M17.347,14.281l-.022-.007c.22-.665.709-1.207,1.346-1.496-.692-.025-1.365.242-1.854.733l-.016-.016c.505-.508,1.204-.777,1.92-.738l.049.002-.045.019c-.653.28-1.154.827-1.378,1.501Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "straight6",
    "data-name": "straight",
    d: "M16.343,13.132l1.791-1.269-1.097,1.9",
    style: {
      fill: "#f8d000"
    }
  }), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "17.045 13.769 17.025 13.757 18.097 11.903 16.349 13.141 16.336 13.123 18.169 11.824 17.045 13.769"
  })), /*#__PURE__*/React.createElement("path", {
    id: "wavy7",
    "data-name": "wavy",
    d: "M17.336,14.277c.653-.29,1.397-.288,2.047.006-.714.026-1.381.356-1.836.907",
    style: {
      fill: "#f8d000"
    }
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M17.557,15.197l-.018-.015c.446-.54,1.097-.869,1.795-.909-.637-.272-1.36-.268-1.994.014l-.009-.02c.655-.292,1.404-.289,2.057.006l.044.02-.049.002c-.709.025-1.375.354-1.827.902Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "straight7",
    "data-name": "straight",
    d: "M17.035,13.763l2.128-.536-1.71,1.374",
    style: {
      fill: "#f8d000"
    }
  }), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "17.46 14.611 17.446 14.594 19.115 13.251 17.038 13.774 17.033 13.753 19.212 13.204 17.46 14.611"
  })), /*#__PURE__*/React.createElement("path", {
    id: "wavy8",
    "data-name": "wavy",
    d: "M17.548,15.19c.713-.035,1.407.236,1.908.744-.675-.233-1.417-.167-2.039.183",
    style: {
      fill: "#f8d000"
    }
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M17.421,16.127l-.011-.02c.611-.343,1.338-.414,2.003-.2-.495-.485-1.171-.741-1.865-.707v-.023c.714-.035,1.413.237,1.916.748l.034.035-.047-.016c-.671-.23-1.411-.165-2.03.183Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "straight8",
    "data-name": "straight",
    d: "M17.452,14.602l2.178.269-2.092.664",
    style: {
      fill: "#f8d000"
    }
  }), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "17.542 15.546 17.535 15.524 19.577 14.876 17.451 14.613 17.454 14.59 19.684 14.866 17.542 15.546"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "circle346",
    cx: 15,
    cy: 15.3,
    r: 2.55,
    style: {
      fill: "#f8d000"
    }
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M15,17.861c-1.413,0-2.561-1.15-2.561-2.561s1.15-2.561,2.561-2.561,2.561,1.15,2.561,2.561-1.148,2.561-2.561,2.561ZM15,12.762c-1.399,0-2.539,1.138-2.539,2.539s1.138,2.539,2.539,2.539,2.539-1.138,2.539-2.539-1.139-2.539-2.539-2.539Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path350",
    d: "M0,15.6h30v6.9H0v-6.9Z",
    style: {
      fill: "#183070"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.578,15.343c-.859.344-1.695.344-2.555,0-1.143-.457-2.303-.457-3.445,0-.859.344-1.695.344-2.555,0-1.137-.455-2.34-.457-3.578-.007-.971.354-1.917.354-2.889,0-1.238-.451-2.442-.448-3.578.007-.859.344-1.695.344-2.555,0-1.143-.457-2.303-.457-3.445,0-.859.344-1.695.344-2.555,0-.472-.189-.947-.28-1.423-.313v1.2c.324.031.649.096.977.227,1.143.457,2.303.457,3.445,0,.859-.344,1.695-.344,2.555,0,1.143.457,2.303.457,3.445,0,.867-.346,1.757-.344,2.723.007,1.23.447,2.479.447,3.71,0,.966-.351,1.857-.353,2.723-.007,1.143.457,2.303.457,3.445,0,.859-.344,1.695-.344,2.555,0,.572.228,1.147.343,1.723.343s1.152-.115,1.723-.343c.328-.131.653-.197.977-.227v-1.2c-.475.033-.95.124-1.422.313Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.578,17.743c-.859.344-1.695.344-2.555,0-1.143-.457-2.303-.457-3.445,0-.859.344-1.695.344-2.555,0-1.137-.455-2.34-.457-3.578-.007-.971.354-1.917.354-2.889,0-1.238-.451-2.442-.448-3.578.007-.859.344-1.695.344-2.555,0-1.143-.457-2.303-.457-3.445,0-.859.344-1.695.344-2.555,0-.472-.189-.947-.28-1.423-.313v1.2c.324.031.649.096.977.227,1.143.457,2.303.457,3.445,0,.859-.344,1.695-.344,2.555,0,1.143.457,2.303.457,3.445,0,.867-.346,1.757-.344,2.723.007,1.23.447,2.479.447,3.71,0,.966-.351,1.857-.353,2.723-.007,1.143.457,2.303.457,3.445,0,.859-.344,1.695-.344,2.555,0,.572.228,1.147.343,1.723.343s1.152-.115,1.723-.343c.328-.131.653-.197.977-.227v-1.2c-.475.033-.95.124-1.422.313Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.999,19.83c-.475.033-.95.124-1.422.313-.859.344-1.695.344-2.555,0-1.143-.457-2.303-.457-3.445,0-.859.344-1.695.344-2.555,0-1.137-.455-2.34-.457-3.578-.007-.971.354-1.917.354-2.889,0-1.238-.451-2.442-.448-3.578.007-.859.344-1.695.344-2.555,0-1.143-.457-2.303-.457-3.445,0-.859.344-1.695.344-2.555,0-.472-.189-.947-.28-1.423-.313v1.2c.324.031.649.096.977.227,1.143.457,2.303.457,3.445,0,.859-.344,1.695-.344,2.555,0,1.143.457,2.303.457,3.445,0,.867-.346,1.757-.344,2.723.007,1.23.447,2.479.447,3.71,0,.966-.351,1.857-.353,2.723-.007,1.143.457,2.303.457,3.445,0,.859-.344,1.695-.344,2.555,0,.572.228,1.147.343,1.723.343s1.152-.115,1.723-.343c.328-.131.653-.197.977-.227v-1.2Z",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKi);
export default __webpack_public_path__ + "static/media/KI.39aba958bc519398b2426108a83b798b.svg";
export { ForwardRef as ReactComponent };